import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';

@Injectable({
  providedIn: 'root'
})
export class TcbService {

  constructor(
    private _router: Router,
    private _utilService: UtilService,
    private _httpClient: HttpClient
  ) { }

  // Get TCB coupons
  getTcbCoupons(token: string, userId: any, metadataStatus: any, page: any){
    const URL = environment.apiUrl + 'admin/tcbCoupons';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqParams = new HttpParams()
      .set('user_id', userId)
      .set('metadata_status', metadataStatus)
      .set('page', page);
      
    return this._httpClient.get<any>(URL, {headers: reqHeaders, params: reqParams});
  }

  // Accept/Reject CPG coupon
  addTcbMetadata(token: string, body: any){
    const URL = environment.apiUrl + 'admin/addTcbMetadata';
    let reqHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('authToken', token);
    let reqBody = JSON.stringify(body);

    return this._httpClient.post<any>(URL, reqBody, {headers: reqHeaders});
  }

  
}
